module.exports = __webpack_public_path__ + "static/media/2.e9e3b111.png";